<script setup>
/* Imports */
import {
  computed,
} from 'vue';

/* Helpers */
import {
  mapGetters,
} from '../helpers/mainHelpers.js';

/* Store - Getters */
const {
  getListPrice,
  getHasPrice,
  getDiscountedPrice,
  getHasPricingTextBefore,
  getPricingText,
  getIsPriceLoading,
} = mapGetters();

/* Props */
const props = defineProps({
  map: {
    type: Object,
    default: () => {},
  },
  index: {
    type: Number,
    required: true,
  },
});

const priceDataTestId = (index) => {
  const iterator = index + 1;
  return {
    host: `g__price-${iterator}`,
    originalPrice: {
      wrapper: `g__price__original-price-${iterator}`,
      fromText: `g__price__original-price__from-text-${iterator}`,
      value: `g__price__original-price__value-${iterator}`,
      savingsText: `g__price__original-price__saving-text-${iterator}`,
    },
    discountedPrice: {
      wrapper: `g__price__discounted-price-${iterator}`,
    },
    detailsText: `g__price__details-text-${iterator}`,
    andUpText: `g__price__and-up-text-${iterator}`,
  };
};

/* Prices */
const sku = computed(() => props.map?.sku);
const priceIsLoading = computed(() => getIsPriceLoading.value(sku.value));
const listPrice = computed(() => getListPrice.value(sku.value));
const hasPrice = computed(() => getHasPrice.value(sku.value));
const discountedPrice = computed(() => getDiscountedPrice.value(sku.value));
const hasPricingTextBefore = computed(() => getHasPricingTextBefore.value(sku.value));
const pricingText = computed(() => getPricingText.value(sku.value));
</script>

<template>
  <div class="price__container">
    <g-loader
      v-if="priceIsLoading"
      class="price__loader"
      type="dark"
    />
    <div v-else>
      <template v-if="hasPricingTextBefore && hasPrice">
        <div
          class="price-from-text"
        >
          {{ pricingText }}
        </div>
        <g-price
          class="price"
          :dataTestId.prop="priceDataTestId(props.index)"
          :original-price="listPrice"
          :discounted-price="discountedPrice"
          :has-text="true"
        />
      </template>
      <template v-else-if="hasPrice">
        <g-price
          class="price"
          :dataTestId.prop="priceDataTestId(props.index)"
          :original-price="listPrice"
          :discounted-price="discountedPrice"
          :has-text="true"
          :and-up-text="pricingText"
        />
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.price__container {
  margin-bottom: 0.5rem;
}

.price__loader {
  width: 5rem;
  padding-bottom: 0.5rem; // Used to create equal white-space below loader to match white-space above it
}

.price {
  font-size: 1.125rem;
}
</style>

<style lang="scss">
.g__price {
  display: inline-flex;
}

.price-from-text {
  @include font-primary-weight-bold();
  display: inline;
}
</style>
